module.exports = __webpack_public_path__ + "img/9788960301450.ba65e360.jpg";